import { useEffect, useState } from "react";
import { NotificationManager } from "react-notifications";
import { getErrorFromResponse } from "../../../../../../../../utility/utils";
import { CreacionTrasladoApi } from "../api/CreacionTrasladoApi";

// maneja las existencias de kg secos sobrantes del traslado, de forma análoga
// a las pacas de pallets pero agrupadas por producto
export const useSobranteTraslado = (destinoEsConforme) => {
    const { getExistenciasSobranteDisponibles, cargando } = CreacionTrasladoApi();

    const [filas, setFilas] = useState([]);
    const [search, setSearch] = useState("");

    // mapa producto_id -> kg secos a trasladar
    const [valoresATrasladar, setValoresATrasladar] = useState({});

    // mapa producto_id -> número de tarjeta
    const [tarjetasSalida, setTarjetasSalida] = useState({});

    const GetExistencias = async () => {
        try {
            const params = {
                destino_es_conforme_bodega: destinoEsConforme,
            };
            if (search) params.search = search;

            const response = await getExistenciasSobranteDisponibles(params);
            setFilas(response || []);
        } catch (error) {
            const errorMsg = getErrorFromResponse(
                error,
                "Error al obtener las existencias de sobrante en bodega",
            );
            NotificationManager.error(errorMsg, "Error", 3000);
            setFilas([]);
        }
    };

    // sin tipo de traslado seleccionado no hay un origen que consultar
    useEffect(() => {
        if (destinoEsConforme === undefined) {
            setFilas([]);
            return;
        }
        GetExistencias();
    }, [search, destinoEsConforme]);

    // al cambiar la dirección del traslado, los valores ingresados dejan de tener sentido
    useEffect(() => {
        setValoresATrasladar({});
        setTarjetasSalida({});
    }, [destinoEsConforme]);

    const handleChangeATrasladar = (productoId, valor) => {
        setValoresATrasladar((prev) => ({
            ...prev,
            [productoId]: valor,
        }));
    };

    const handleChangeTarjetaSalida = (productoId, valor) => {
        setTarjetasSalida((prev) => ({
            ...prev,
            [productoId]: valor,
        }));
    };

    const totalKgATrasladar = Object.values(valoresATrasladar).reduce(
        (acc, valor) => acc + (Number(valor) > 0 ? Number(valor) : 0),
        0,
    );

    const obtenerFilasATrasladar = () => {
        return Object.entries(valoresATrasladar)
            .filter(([, valor]) => Number(valor) > 0)
            .map(([productoId, valor]) => ({
                producto_id: Number(productoId),
                kg_secos_a_trasladar: Number(valor),
                tarjeta_salida: (tarjetasSalida[productoId] || "").trim() || null,
            }));
    };

    return {
        filas,
        search,
        handleSearch: setSearch,

        valoresATrasladar,
        handleChangeATrasladar,
        tarjetasSalida,
        handleChangeTarjetaSalida,
        totalKgATrasladar,
        obtenerFilasATrasladar,

        cargando,
    };
};
